var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keyboard',{attrs:{"type":"1","shadow":"2px 2px 5px 1px rgba(0, 0, 0, 0.3)","place":"请扫码或输入会员号/会员手机号"},on:{"ok":_vm.ok,"clear":_vm.clear},model:{value:(_vm.numbers),callback:function ($$v) {_vm.numbers=$$v},expression:"numbers"}})}
var staticRenderFns = []

export { render, staticRenderFns }